import { TournamentEntity, UserEntity } from 'app/interfaces/entity';
import { sessionSelector } from 'app/store/session/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { currentTournamentSelector } from '../store/current-tournament/selectors';
import { useCurrentUserTeamId } from 'modules/tournaments/hooks/use-current-user-team-id';
import { useUserWinningAnimation } from 'shared/hooks';

export const useTeamDetails = () => {
  const activeUser: Partial<UserEntity> = useSelector(sessionSelector.activeUser);
  const tournament: TournamentEntity = useSelector(currentTournamentSelector.tournament);
  const { currentUserTeamId } = useCurrentUserTeamId(tournament);

  const currentUserTeamSubmittedScore = useMemo(
    () =>
      tournament?.results
        ?.filter((result) => result?.teamId === currentUserTeamId)
        ?.map((result) => result.score ?? 0),
    [tournament?.results, currentUserTeamId]
  );

  const isScoreSubmitted = useMemo(() => {
    if (!tournament?.matchSetupSettings?.maxSubmissions) {
      return false;
    }

    return currentUserTeamSubmittedScore?.length >= tournament?.matchSetupSettings?.maxSubmissions;
  }, [currentUserTeamSubmittedScore, tournament]);

  const { isWinningAnimationAvailable } = useUserWinningAnimation(tournament, activeUser);

  return {
    isWinningAnimationAvailable,
    isScoreSubmitted,
  };
};
